<template>
    <div class="promo-info">
        <div class="edit-camp-header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="height-aaa d-flex w-100 justify-content-between align-items-center">
                            <BreadCrumbs :items="crumbs"/>
                            <div class="tabs-actions d-flex py-2 ml-auto justify-content-end">
                                <button
                                    @click="$router.go(-1)"
                                    id="cancel-edit-campaign"
                                    class="cancel-button p2b c3">
                                        Cancel
                                </button>
                                <button
                                    @click="save"
                                    id="save-edit-campaign"
                                    :disabled="loading"
                                    type="button"
                                    class="phiolet_button p2b c16 ml-4 cursor-pointer">
                                        <span v-if="!loading">Save</span>
                                        <span v-else>Saving...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mb-3" v-if="showColumns">
            <div class="row">
                <div class="col">
                    <div class="left-side  mx-auto my-3">
                        <div class="left-side-content mx-auto">
                            <Heading
                                fullWidth
                                title="Set your updates schedule"
                                description="Add your planned update dates and spots.
                                This will speed up your cross-promotion agreements."
                            />
                        </div>
                        <AddUpdates
                            @setChildEvent = "setChildEvent"
                            :card-data="cardData"
                            model="campaigns"/>
                    </div>
                </div>
                <div class="col">
                    <div class="right-side mx-auto my-3">
                        <div class="right-side-content mx-auto">
                            <Heading
                                fullWidth
                                title="CrossProm Info"
                                description="Cross-promotion information is the promotional material that you partners are to place in their update."
                            />
                            <EditCrossPromInfo
                                ref="editInfo"
                                :cardData="cardData"
                                @updateCardInfo="updateCardInfo"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <UnsavedChanges 
            v-if="prompt"
            :loading="loading"
            @submit="save"
            @cancel="$router.push(prompt).catch(() => {})"
            @close="prompt = null"
            @no="$router.push(prompt).catch(() => {})"/>
    </div>
</template>

<script>
import AddUpdates from '../components/wizard-steps/AddUpdates.vue'
import { message } from 'ant-design-vue'
import UnsavedChanges from '../popups/UnsavedChanges'
import BreadCrumbs from "../components/Theme/BreadCrumbs";
import Heading from "../components/Theme/Heading";
import EditCrossPromInfo from "../components/EditCrossPromInfo";
import { getDataByDocId } from "@/firebaseCRUD";
import {mapState} from "vuex";


export default {
    name: 'PromoInfo',
    components: {
        EditCrossPromInfo,
        AddUpdates,
        UnsavedChanges,
        BreadCrumbs,
        Heading
    },
    data() {
        return {
            prompt: null,
            loading: false,
            childEvent: null,
            cardData: {},
            isOwner: true,
            showColumns: false
        }
    },
    beforeRouteLeave: function(to, from, next) {
        if(this.isOwner && !this.prompt && this.$refs.editInfo && this.$refs.editInfo.hasUnsavedChanges(this.cardData) && to.name !== '404') {
                this.prompt = to.fullPath
                return 
        }
        next()
    },
    computed: {
        ...mapState([
            'user',
        ]),
        crumbs(){
            return [
                { title: 'My Campaigns' },
                { title: 'Published', link: '/dashboard/campaigns/publish' },
                { title: this.cardData && this.cardData.promo_title }
            ]
        }
    },

    watch: {
        '$route.query.id': 'getData',
        'cardData': function(val){
            if(val && val.author_id && this.user.uid !== val.author_id) {
                this.isOwner = false;
                this.$router.push('/').catch(() => {});
            }
        }
    },
    mounted: function() {
        if(this.$route.query.id){
            this.getData();
            this.showColumns = true;
        } else {
            this.$router.push('/404').catch(() => {});
        }
    },
    methods: {
        async getData() {
            if (!this.$route.query.id) return;
            const doc = await getDataByDocId ({
                collection: 'campaigns',
                id: this.$route.query.id
            })

            this.cardData = doc.data()
        },
        setChildEvent(event) {
            this.childEvent = event;
        },
        updateCardInfo({ promo_title, promo_desc, promo_image }){
            this.cardData.promo_title = promo_title
            this.cardData.promo_desc = promo_desc
            this.cardData.promo_image = promo_image
        },
        async save() {
            this.loading = true;

            await this.$refs.editInfo.save();

            if (this.childEvent.next) {
                try {
                    await this.childEvent.next()
                } catch (e) {
                    console.log(e)
                    console.log('error saving spots')
                } finally {
                    this.loading = false
                }
            }

            this.$router.go(this.prompt || -1)
            message.success('Changes successfully saved!')
        },
    },
}
</script>

<style scoped lang="scss">
    .promo-info {
        .edit-camp-header {
            background: #FFFFFF;
            border-top: 1px solid #F4F4F4;
            border-bottom: 1px solid #F4F4F4;
        }
        .height-aaa {
            height: 100px;
        }
        .left-side,.right-side {
            width: 560px;
            height: 792px;
            padding-top: 50px;
            background: #FFFFFF;
            box-shadow: 0 0 35px rgba(154, 161, 171, 0.15);
            border-radius: 10px;

            #add-updates {
                padding: 0 !important;
            }
        }
        .left-side-content, .right-side-content {
            max-width: 480px;
        }
        
        .right-side-content {
            .side-content {
                width: 430px;
                border-top: 1px solid #F4F4F4;
                max-height: 670px;
                .prod-desc {
                    p {
                        line-height: 28px;
                    }
                    textarea {
                        font-size: 19px;
                        line-height: 28px;
                        color: #858585;
                    }
                }
                .prod-title, .prod-desc {
                    line-height: 28px;
                    img {
                        top: 0;
                        left: 100%;
                        transform: translate(10px, 0);
                    }
                    p {
                        position: absolute;
                        top: 0;
                        right: 0;
                        transform: translate(0, -22px);
                    }
                }
                textarea {
                    width: 100%;
                    border: 0;
                    font-weight: bold;
                    font-size: 27px;
                    color: #333333;
                    resize: none;

                    &#promo_title {
                        height: 80px;
                    }
                    &#desc {
                        height: 200px;
                    }
                    &.enabledTextarea {
                        border: 1px solid #00000026;
                    }
                    &.maxLength {
                        border: 1px solid #FA5C7C !important;
                    }
                }
            }
            
        }
    }
    .tabs-actions {
        button, a {
            display: block;
            width: 89px;
            height: 48px;
            text-align: center;
            // line-height: 48px;
        }
    }
</style>